import gql from 'graphql-tag';

export const updateReferralCode = gql`
  mutation updateReferralCode($id: Int!, $active: Boolean){
    updateReferralCode( id: $id, active: $active ){
      id
    }
  }
`;
